import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { PricingConfiguratorManager } from '@ctct/application-layer';
import { isStripeBillingStrategy } from '@ctct/domain-layer';
import { useBillingStrategy, useIsSocialStarter } from '@ctct/state-server-layer';

interface Props {
  initializer: Pick<PricingConfiguratorManager, 'pricingConfiguratorInit'>;
}

export const usePricingConfiguratorWidget = ({ initializer }: Props) => {
  const { t } = useTranslation();
  const socialStarterQuery = useIsSocialStarter();
  const billingStrategy = useBillingStrategy();
  const isStripe = isStripeBillingStrategy(billingStrategy);

  const componentProps = useMemo(
    () =>
      initializer.pricingConfiguratorInit({
        t,
        isStripe,
      }),
    [initializer, t, isStripe]
  );

  return {
    ...componentProps,
    isSocialStarter: socialStarterQuery.isSocialStarter,
  };
};
